import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ISummarySectorAir } from '../../shared/interfaces/ISummary';
import { SectorAirGroupService } from './sector-air-group.service';
import { IDescriptionLabels } from "../../../../../../../module/formbuilder/fields/form-field/components/field-description/field-description.component";
import { faCircle, faQuestion, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { Yii } from "../../../../../../../interfaces/Yii";

@Component({
  selector: 'sector-air-group',
  template: `
  <div *ngIf="sector.marriageGroup">
    Groupe
    <fa-layers *ngIf="description" (click)="showDescription=!showDescription">
      <fa-icon [icon]="iconCircle" class="blue"></fa-icon>
      <fa-icon [icon]="iconQuestion" class="white" transform="shrink-5" ></fa-icon>
    </fa-layers>: {{sector.marriageGroup}}
  </div>

  <field-description *ngIf="showDescription" [description]="description"
                     (clickOutside)="showDescription=!showDescription"></field-description>
  <input type="checkbox" [checked]="isChecked" (input)="updateMariageGroupChecked()">
  `,
  styles: [`
    input {
      width: 1rem;
      height: 1rem;
    }
    field-description {
      position: absolute;
      z-index: 3;
    }
    fa-icon {
      cursor: pointer;
    }
    fa-layers {
      padding: 0 .4rem;
    }
    fa-icon.blue {
      color: #337ab7;
    }
    fa-icon.white {
       color: white;
    }
    fa-layers:hover .blue {
       color: #414141;
    }
  `]
})
export class SectorAirGroupComponent implements OnInit, OnDestroy {
  @Input()
  public sector: ISummarySectorAir;
  @Input()
  public sectorsChecked: ISummarySectorAir[];
  public iconQuestion: IconDefinition = faQuestion;
  public iconCircle: IconDefinition = faCircle;
  public isChecked: boolean = false;
  public sectorAirGroupServiceSubscription: Subscription;
  public description:  IDescriptionLabels;
  public showDescription: boolean = false;

  constructor(private sectorAirGroupService: SectorAirGroupService) { }

  public ngOnInit(): void {
    this.initIsChecked();
    this.initDescription();
    this.sectorAirGroupServiceSubscription = this.sectorAirGroupService.marriageGroupCheckedObs
        .subscribe((sectorMarriageGroup: string | boolean) => {
          if (typeof sectorMarriageGroup === 'boolean') {
            this.isChecked = sectorMarriageGroup;
          } else {
            if (this.sector.marriageGroup && this.sector.marriageGroup === sectorMarriageGroup) {
              this.isChecked = !this.isChecked;
              this.sectorAirGroupService.updateSectorXIds(this.sector.xId);
            }
          }
        });
  }

  public ngOnDestroy(): void {
    this.sectorAirGroupServiceSubscription.unsubscribe();
  }

  public updateMariageGroupChecked(): void {
    if (this.sector.marriageGroup) {
      this.sectorAirGroupService.updateSectorMarriageGroups(this.sector.marriageGroup);
    } else {
      this.isChecked=!this.isChecked;
      this.sectorAirGroupService.updateSectorXIds(this.sector.xId);
    }
  }

  private initDescription(): void {
    this.description = {
      main: Yii.t('wui-sasha-js', 'Groupe d\'appartenance au segment'),
      detailIntroduction: Yii.t('wui-sasha-js', 'La modification / suppression du segment s\'applique à tous les segments du même groupe')
    };
  }

  private initIsChecked(): void {
    this.isChecked = this.sectorsChecked && this.sectorsChecked.some((sector: ISummarySectorAir): boolean => sector.xId === this.sector.xId);
  }
}
